/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_Account_ChangePasswordInput } from '../models/Routemize_DTOs_Account_ChangePasswordInput';
import type { Routemize_DTOs_Account_ProfileDto } from '../models/Routemize_DTOs_Account_ProfileDto';
import type { Routemize_DTOs_Account_UpdateProfileDto } from '../models/Routemize_DTOs_Account_UpdateProfileDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProfileService {
    /**
     * @returns Routemize_DTOs_Account_ProfileDto OK
     * @throws ApiError
     */
    public static getApiAccountMyProfile(): CancelablePromise<Routemize_DTOs_Account_ProfileDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/account/my-profile',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_Account_ProfileDto OK
     * @throws ApiError
     */
    public static putApiAccountMyProfile(
        requestBody?: Routemize_DTOs_Account_UpdateProfileDto,
    ): CancelablePromise<Routemize_DTOs_Account_ProfileDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/account/my-profile',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAccountMyProfileChangePassword(
        requestBody?: Routemize_DTOs_Account_ChangePasswordInput,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/account/my-profile/change-password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
